import MoveTo from "../Utils/MoveToController";
import DocNavigationController from "./DocNavigationController";

export default class InpageAnchor {
	constructor() {
		this.links = Array.from(document.querySelectorAll(".js-inpage-anchor"));
		this.onLinkClicked = ::this.onLinkClicked;
		this.initEvents();
	}

	initEvents() {
		this.links.forEach(link => {
			link.addEventListener("click", this.onLinkClicked);
		});
	}

	onLinkClicked(e, offset = DocNavigationController.getOffset()) {
		e.preventDefault();
		const id = e.currentTarget.getAttribute("href");
		const partner = document.querySelector(id);
		let scrollTarget = partner.getBoundingClientRect().top;
		if (offset) scrollTarget -= offset;
		if (
			window.innerWidth < 992 &&
			e.currentTarget.classList.contains("js-enter-doc") === false
		)
			scrollTarget = partner.getBoundingClientRect().top - 84;

		if (scrollTarget !== 0) MoveTo.move(scrollTarget);
	}
}



// WEBPACK FOOTER //
// ./Components/InpageAnchor.js